// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: admin/model/AdminPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ModifiersPayload } from "../../common/model/ModifiersPt";

export const protobufPackage = "io.teamsillim.fightbracket.idl.admin.model";

/**
 * 관리자 권한
 *
 * 운영자는 대회 · 신청 · 대진을 다루고, 마스터는 관리자 계정까지 다룬다.
 */
export enum AdminRolePayload {
  ADMIN_ROLE_UNKNOWN = 0,
  /** ADMIN_ROLE_OPERATOR - 운영자 */
  ADMIN_ROLE_OPERATOR = 1,
  /** ADMIN_ROLE_MASTER - 마스터 */
  ADMIN_ROLE_MASTER = 2,
  UNRECOGNIZED = -1,
}

export function adminRolePayloadFromJSON(object: any): AdminRolePayload {
  switch (object) {
    case 0:
    case "ADMIN_ROLE_UNKNOWN":
      return AdminRolePayload.ADMIN_ROLE_UNKNOWN;
    case 1:
    case "ADMIN_ROLE_OPERATOR":
      return AdminRolePayload.ADMIN_ROLE_OPERATOR;
    case 2:
    case "ADMIN_ROLE_MASTER":
      return AdminRolePayload.ADMIN_ROLE_MASTER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AdminRolePayload.UNRECOGNIZED;
  }
}

export function adminRolePayloadToJSON(object: AdminRolePayload): string {
  switch (object) {
    case AdminRolePayload.ADMIN_ROLE_UNKNOWN:
      return "ADMIN_ROLE_UNKNOWN";
    case AdminRolePayload.ADMIN_ROLE_OPERATOR:
      return "ADMIN_ROLE_OPERATOR";
    case AdminRolePayload.ADMIN_ROLE_MASTER:
      return "ADMIN_ROLE_MASTER";
    case AdminRolePayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * 관리자 계정 Payload (TB_ADMIN 과 1:1)
 *
 * 비밀번호는 어떤 응답에도 실리지 않는다 — 해시조차 내려보내지 않는다.
 */
export interface AdminPayload {
  /** 고유 id */
  id: string;
  /** 로그인 아이디 */
  loginId: string;
  /** 관리자명 */
  name: string;
  /** 권한 */
  role: AdminRolePayload;
  /** 잠금 여부 (로그인 연속 실패로 잠긴다) */
  isLocked: boolean;
  /** 최종 로그인 일시 (format = yyyy-MM-dd'T'HH:mm:ss'Z') */
  lastLoginAt: string;
  /** 수정 정보 */
  modifiers: ModifiersPayload | undefined;
}

function createBaseAdminPayload(): AdminPayload {
  return { id: "", loginId: "", name: "", role: 0, isLocked: false, lastLoginAt: "", modifiers: undefined };
}

export const AdminPayload: MessageFns<AdminPayload> = {
  encode(message: AdminPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.loginId !== "") {
      writer.uint32(18).string(message.loginId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.role !== 0) {
      writer.uint32(32).int32(message.role);
    }
    if (message.isLocked !== false) {
      writer.uint32(40).bool(message.isLocked);
    }
    if (message.lastLoginAt !== "") {
      writer.uint32(50).string(message.lastLoginAt);
    }
    if (message.modifiers !== undefined) {
      ModifiersPayload.encode(message.modifiers, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.loginId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isLocked = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.lastLoginAt = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.modifiers = ModifiersPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminPayload {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      loginId: isSet(object.loginId) ? globalThis.String(object.loginId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      role: isSet(object.role) ? adminRolePayloadFromJSON(object.role) : 0,
      isLocked: isSet(object.isLocked) ? globalThis.Boolean(object.isLocked) : false,
      lastLoginAt: isSet(object.lastLoginAt) ? globalThis.String(object.lastLoginAt) : "",
      modifiers: isSet(object.modifiers) ? ModifiersPayload.fromJSON(object.modifiers) : undefined,
    };
  },

  toJSON(message: AdminPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.loginId !== "") {
      obj.loginId = message.loginId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.role !== 0) {
      obj.role = adminRolePayloadToJSON(message.role);
    }
    if (message.isLocked !== false) {
      obj.isLocked = message.isLocked;
    }
    if (message.lastLoginAt !== "") {
      obj.lastLoginAt = message.lastLoginAt;
    }
    if (message.modifiers !== undefined) {
      obj.modifiers = ModifiersPayload.toJSON(message.modifiers);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminPayload>, I>>(base?: I): AdminPayload {
    return AdminPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminPayload>, I>>(object: I): AdminPayload {
    const message = createBaseAdminPayload();
    message.id = object.id ?? "";
    message.loginId = object.loginId ?? "";
    message.name = object.name ?? "";
    message.role = object.role ?? 0;
    message.isLocked = object.isLocked ?? false;
    message.lastLoginAt = object.lastLoginAt ?? "";
    message.modifiers = (object.modifiers !== undefined && object.modifiers !== null)
      ? ModifiersPayload.fromPartial(object.modifiers)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
